import CarsService from '~/services/cars.service';
import { EXPENSES } from '~/lib/constants';
import { CreateCarModel } from '~/models/car';
import { CreateLeasedCarModel } from '~/models/car-leased';
import { gameActions, uiActions, productsActions } from '~/store/actions';
import { carSelectors, gameSelectors } from '~/store/selectors';
import { inboxActions, loadingActions } from '~/store';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- parent imports ----

export function fetchAllCars() {
	return async (dispatch) => {
		try {
			const result = await CarsService.fetchAllCars();
			if (!result.isSuccess) {
				return;
			}

			const allCars = result.data;

			const allCarsFormatted = allCars.reduce((acc, car) => {
				const carModel = CreateCarModel(car);
				acc[carModel.id] = carModel;
				return acc;
			}, {});
			dispatch({ type: types.CAR_FETCHED_ALL, allCars: allCarsFormatted });
		} catch (error) {
			console.error(error);
		}
	};
}

export function fetchLeasedCars() {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());
			const result = await CarsService.fetchLeasedCars(gameUserId);
			if (!result.isSuccess) {
				return;
			}

			const leasedCars = result.data;

			const leasedCarsFormatted =
				leasedCars.map((car) => {
					const carInfo = carSelectors.getCar(getState(), car.car_id);
					return CreateLeasedCarModel(car, carInfo);
				});
			dispatch({ type: types.CAR_FETCHED_LEASED, leasedCars: leasedCarsFormatted });
		} catch (error) {
			console.error(error);
		}
	};
}

export function unlease(leasedCarId) {
	return async (dispatch, getState) => {
		try {
			const gameUserId = gameSelectors.getGameId(getState());
			
			dispatch(loadingActions.start(types.CAR_UNLEASED));
			const result = await CarsService.unleaseCar(gameUserId, leasedCarId);
			if (!result.isSuccess) {
				dispatch(loadingActions.endAfterNetworkFaliures());
				return false;
			}

			const {
				cars: leasedCars,
				products
			} = result.data;
			dispatch(loadingActions.end(types.CAR_UNLEASED));

			dispatch({ type: types.CAR_UNLEASED });

			const leasedCarsFormatted =
				leasedCars.map((car) => {
					const carInfo = carSelectors.getCar(getState(), car.car_id);
					return CreateLeasedCarModel(car, carInfo);
				});
			dispatch({ type: types.CAR_FETCHED_LEASED, leasedCars: leasedCarsFormatted });

			// Update Product Prices
			const mappedProducts = gameActions.mapProducts(products);
			dispatch(productsActions.productsLoaded(mappedProducts));

			return true;
		} catch (error) {
			console.error(error);
		}
	};
}

export function lease(carId) {
	return async (dispatch, getState) => {
		try {
			dispatch(loadingActions.start(types.CAR_LEASED));
			const gameUserId = gameSelectors.getGameId(getState());

			const result = await CarsService.leaseCar(gameUserId, carId);
			if (!result.isSuccess) {
				dispatch(loadingActions.endAfterNetworkFaliures());
				return false;
			}

			const {
				cars: leasedCars,
				products,
				notifications
			} = result.data;
			await dispatch(loadingActions.end(types.CAR_LEASED));

			const leasedCarsFormatted = leasedCars.map((car) => {
				const carInfo = carSelectors.getCar(getState(), car.car_id);
				return CreateLeasedCarModel(car, carInfo);
			});

			dispatch({ type: types.CAR_FETCHED_LEASED, leasedCars: leasedCarsFormatted });
			const car = carSelectors.getCar(getState(), carId);
			dispatch({ type: types.CAR_LEASED, car });

			if (notifications) {
				dispatch(inboxActions.handleNewMessage(notifications))
			}

			const shouldShowExpenseThisRound =
				!carSelectors.hasCarUnleasedThisTurn(getState());
			if (shouldShowExpenseThisRound) {
				dispatch(uiActions.addNewExpenseToDisplay(EXPENSES.CAR, car.price));
			}

			// Update Product Prices
			const mappedProducts = gameActions.mapProducts(products);
			dispatch(productsActions.productsLoaded(mappedProducts));

			return true;
		} catch (error) {
			console.error(error);
		}

	};
}
